import type { UtilityContext } from '@change-corgi/core/react/utilityContext';
import { FCM_DM_PROFILE_REDESIGN } from '@change-corgi/fcm/configs';

export async function getDmProfileRedesignConfig(utilityContext: UtilityContext): Promise<{
	profileCard: boolean;
	targetedPetitionList: boolean;
	sapToDm: boolean;
	responseList: boolean;
}> {
	const { dmProfileRedesignConfig } = await utilityContext.fcm.get({
		dmProfileRedesignConfig: FCM_DM_PROFILE_REDESIGN,
	});

	return dmProfileRedesignConfig;
}
